import React, {useEffect, useState} from "react";
import dash from "./assets/dash.png";
import invoice_list from "./assets/invoice_list.png"
import wizard from "./assets/wizard.png"
import ProgressDots from "./assets/ProgressDots";
import notification from "./assets/notifications.png";
import { useMediaQuery } from 'react-responsive'
import EmailIcon from './assets/EmailIcon';
import WaveBackdrop from './assets/WaveBackdrop';
import { Logo, BRAND_NAME, BRAND_SUPPORT_EMAIL, APP_URL } from "./brand";

export default function Landing(props) {

    const [prevY, setPrevY] = useState(0); 
    const [currentY, setCurrentY] = useState(0) 
    const [navHeight, setNavHeight] = useState("0px");
    const [buttonTranslate, setButtonTranslate] = useState(false);  
    const isMobile = useMediaQuery({ query: '(max-width: 480px)' });

    const handleScroll = () => {
        setCurrentY(window.scrollY);  
    }
    useEffect(() => {
        // when scrolling down, hide nav & CTA button. When scrolling up, show them
        if (currentY > prevY && navHeight === "0px") {
            setNavHeight("-70px");
            setButtonTranslate(true)
        } else if (currentY < prevY && navHeight === "-70px") {
            setNavHeight("0px");
            setButtonTranslate(false)
        } 
        setPrevY(currentY)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentY])

    useEffect(() => {
        // listen fro scrolling when component is mounted
        window.addEventListener("scroll", () => handleScroll());
        return () => {
            window.removeEventListener("scroll", () => handleScroll());
        }
    }, []);

    // eslint-disable-next-line no-unused-vars
    const onClickContact = () => {
        document.getElementById('contact_us').scrollIntoView({behavior: "smooth"});
    }

    return (
        <>
            <WaveBackdrop />
            <nav
                style={{transform: `translate(0, ${navHeight})`,transition: "transform 350ms linear"}}
                className={currentY === 0 ? "hideshadow": ""}
            >
                <div>
                    <Logo height={isMobile ? "32px" : "34px"} />
                </div>
                <ul>
                    {/* <li><button className="">About us</button></li>
                    <li><button className="">About us</button></li> */}
                    <li>
                        <a href={`${APP_URL}/#/login`} >
                            <button className="btn sec black">Log in</button>
                        </a>
                    </li>
                    <li>
                        <a href={`${APP_URL}/#/register`} >
                            <button className="btn pri blue">Sign up</button>
                        </a>
                    </li>
                </ul>
            </nav>
            <header>
                <div className="main-margin grid-par g12 ">
                    <div style={isMobile ? {gridColumn: "1 / span 8"} : {gridColumn: "1 / span 5"}} className="grid-chi hero-info">

                        <h1 >Document Exchange & Tracking for Contractors, Projects & Teams</h1>
                        <p>Simplify the billing process by illuminating your invoice flow</p>

                        {/* <button 
                            className={"btn pri black " + (isMobile && (buttonTranslate ? "hidebutton" : "showbutton") )}
                            onClick={() => onClickContact()}
                            >Learn more
                        </button> */}

                        <a href={`${APP_URL}/#/register`} >
                            <button className={"btn pri black " + (isMobile && (buttonTranslate ? "hidebutton" : "showbutton") )}>
                                Sign up
                            </button>
                        </a>

                    </div>
                    {/* <Hero with="100%" svgClass="grid-chi w100" svgStyle={isMobile ? {gridColumn: "1 / span 8", paddingBottom: "20px"} : {gridColumn: "7 / span 6"}} /> */}
                </div>
            </header>
            <section>
                <div className="main-margin grid-par g12 ">
                    <div style={isMobile ? {gridColumn: "2 / span 6"} : {gridColumn: "1 / span 4"}} className="grid-chi para-container">
                        <ProgressDots className="progress-container" svgClass="progress" progress={1} />
                        <h2 >Keep your invoice records organized</h2>
                        <p>Have confidence that no invoices have been missed and that approval and payment dates/deadlines are fully illuminated. Know precisely when your actions are required and view the actions of others.</p>
                    </div>
                    <img style={isMobile ? {gridColumn: "1 / span 8"} : {gridColumn: "6 / span 7"}} className="span4 grid-chi w100 shadow" src={invoice_list} alt="" />
                </div>
            </section>
            <section className="greyback">
                <div className="main-margin grid-par g12">
                    {!isMobile && 
                    <img style={{gridColumn: "1 / span 12"}} className={"grid-chi w100 " + (!isMobile && "stacked")} src={wizard} alt="" />
                    }
                    <div style={isMobile ? {gridColumn: "2 / span 6"} : {gridColumn: "9 / span 4"}} className="span3 grid-chi para-container">
                        <ProgressDots className="progress-container" svgClass="progress" progress={2} />
                        <h2 >Stay up to date on each invoice status</h2>
                        <p>View the workflow of each invoice and instantly know whom is responsible for actions along the invoicing process. Coordinate all teams in one place.</p>
                    </div>
                </div>
            </section>
            <section>
                <div className="main-margin grid-par g12 ">
                    <div style={isMobile ? {gridColumn: "2 / span 6"} : {gridColumn: "1 / span 4"}} className="span3 grid-chi para-container">
                        <ProgressDots className="progress-container" svgClass="progress" progress={3} />
                        <h2 >Get notified when it's time to take action</h2>
                        <p>Automatically send and receive notifications between teams when key items are processed. Streamline communication across billing stakeholders.</p>
                    </div>
                    <img style={isMobile ? {gridColumn: "2 / span 6"} : {gridColumn: "8 / span 5"}} className="span4 grid-chi w100 shadow" src={notification} alt="" />
                </div>
            </section>
            <section className="greyback">
                <div className="main-margin grid-par g12">
                    <img style={isMobile ? {gridColumn: "1 / span 8", gridRow: 2} : {gridColumn: "1 / span 7"}} className="span4 grid-chi w100 shadow" src={dash} alt="" />
                    <div style={isMobile ? {gridColumn: "2 / span 6"} : {gridColumn: "9 / span 4"}} className="span3 grid-chi para-container">
                        <ProgressDots className="progress-container" svgClass="progress" progress={4} />
                        <h2 >Keep track of the big picture</h2>
                        <p>View real-time analytics and turn your project information into insights that are both meaningful and actionable. Guide your business with current and historical information.</p>
                    </div>
                </div>
            </section>
            <footer >
                    <div className="main-margin grid-par g12">
                        <div style={isMobile ? {gridColumn: "2 / span 6"} : {gridColumn: "5 / span 4"}} className="grid-chi">
                            <h2 >Want to learn more?</h2>
                            <p>Get in touch with our team to find out how <span style={{whiteSpace: "nowrap"}}>{BRAND_NAME}</span> can help you on the job site.</p>
                            <a href={`mailto:${BRAND_SUPPORT_EMAIL}`} id="contact_us" >
                                <div className="iblock gap-r-xs">
                                    <EmailIcon height="14px" color="white" />
                                </div>
                                <h3 className="iblock" >{BRAND_SUPPORT_EMAIL}</h3>
                            </a>
                            {/* <button className="btn">Contact us</button> */}
                        </div>
                    </div>
            </footer>
        </>
    )
}